import { makeStyles } from "@material-ui/core";
import {
  KeyboardDatePicker,
  KeyboardDatePickerProps,
} from "@material-ui/pickers";
import { getKeyboardPickerDateFormat } from "../utils/dateTimeFormatting";

type IProps = KeyboardDatePickerProps;

export const KeyboardDatePickerInput = (props: IProps) => {
  const { InputProps, ...rest } = props;
  const classes = useStyles();

  return (
    <KeyboardDatePicker
      {...rest}
      variant="dialog"
      data-automation="end-date-picker"
      margin="normal"
      fullWidth
      inputVariant="outlined"
      InputProps={{
        classes: {
          root: classes.cssOutlinedInput,
          focused: classes.cssFocused,
        },
        readOnly: true,
        ...InputProps,
      }}
      format={getKeyboardPickerDateFormat()}
    />
  );
};
const useStyles = makeStyles(() => ({
  cssOutlinedInput: {
    paddingRight: 4,
    display: "flex",
  },
  cssFocused: {},
}));
